import React  from 'react'
import footer from '../Styles/Footer.css'
const Footer = () =>{
    return(
        <div className='footer'>
            <h6>Made with ❤️️ for VIT students</h6>
        </div>
    )
}
 
export default Footer;